import withStyles, { WithStylesProps } from "react-jss";

const styles = {
  button: {
    color: "#ffffff !important",
    height: "75px !important",
    width: "75px !important",
    "background-color": "transparent",
    border: "none",
    outline: "none",
    margin: "0px 20px 0px 20px",
    transition: "color 0.75s",
    "&:hover": {
      color: "#5E1219 !important",
    },
    "align-items": "flex-end",
    "z-index": "99",
    cursor: "pointer",
    "@media (max-width: 600px)": {
      height: "55px !important",
      width: "55px !important",
      margin: "0px 8px",
    },
    "@media (max-width: 400px)": {
      height: "45px !important",
      width: "45px !important",
      margin: "0px 6px",
    },
  },
};

interface IProps extends WithStylesProps<typeof styles> {
  children: React.ReactNode;
  classes: any;
  onClick: () => void;
}

const Button: React.FunctionComponent<IProps> = ({
  classes,
  children,
  onClick,
}) => {
  return (
    <button type="button" className={classes.button} onClick={onClick}>
      {children}
    </button>
  );
};

export default withStyles(styles)(Button);
